var exports = {
  "Kk": "icon__Sf_Nku",
  "DD": "title__MTYMi3",
  "Pf": "label__-LB4TR",
  "nf": "link__3viuP9",
  "VA": "subtitle__gxA0qn",
};

module.exports = exports;
